import { render, staticRenderFns } from "./LoginExternoEscritorio.vue?vue&type=template&id=6d2dcc56&scoped=true&"
import script from "./LoginExternoEscritorio.vue?vue&type=script&lang=js&"
export * from "./LoginExternoEscritorio.vue?vue&type=script&lang=js&"
import style0 from "./LoginExternoEscritorio.vue?vue&type=style&index=0&id=6d2dcc56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2dcc56",
  null
  
)

export default component.exports